import React from 'react'

import { AccessibleTooltip } from './AccessibleTooltip'

/**
 * Explains why a scan button is disabled, the same way the disabled "View
 * Results" button explains itself: a tooltip on a wrapping span, since a
 * disabled button fires no hover or focus events of its own. Renders the
 * button unchanged when nothing blocks the scan.
 */
export function ScanBlockedTooltip({
  reason,
  children,
}: {
  reason: string | null
  children: React.ReactElement
}) {
  if (!reason) return children
  return (
    <AccessibleTooltip title={reason} arrow placement="top">
      <span style={{ display: 'inline-block', width: '100%' }}>{children}</span>
    </AccessibleTooltip>
  )
}
